
import {timer as observableTimer,  Observable ,  Subscription } from 'rxjs';

import { AfterViewChecked, Component, DoCheck, EventEmitter, Input, OnDestroy,OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';

import { AuthenticationService } from '../core/authentication/authentication.service';
import { NavMenuService } from './nav-menu.service';
import { NavMenuVersionService } from './nav-menu-version.service';
import { MenuLinkModel } from '../models/menu-link.model';
import { LocalStorage, SessionStorage } from 'ngx-webstorage';

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnDestroy, DoCheck, AfterViewChecked{

  app_version: string = '';
  app_environment: string = '';
  isExpanded = false;
  isExpandedV = true;
  menuLinks: MenuLinkModel[] = [];
  oldMenuLinks: MenuLinkModel[] = [];
  menuSubscription: Subscription = null;
  routerSubscription: Subscription = null;
  timer1Subscription: Subscription = null;
  timer2Subscription: Subscription = null;

  @Input()
  isCollapsed: boolean = false;

  @Output()
  isCollapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  verticalExpand: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private menu: NavMenuService,
    private navMenuVersionService: NavMenuVersionService,
    private location: Location,
    private router: Router,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.app_version = this.menu.getAppVersion();
    this.app_environment = this.menu.getAppEnvironment();

    this.menuSubscription = this.menu.subscribe(m => this.menuLinks = m);

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        //$('#main.menu a[aria-expanded="true"]').trigger('click');
      }
    });

    // app_version check
    // Wait 1 minute - then check the app_version every 1 minute.
    const timer = observableTimer(60000, 60000);
    this.timer1Subscription = timer.subscribe(t => {
      // Make a call to the server to determine if the version has changed
      this.navMenuVersionService.getAppVersion().subscribe(data => {
        if (data.AppVersion !== this.app_version) {
          // App Version changed - save it to local storage
          this.app_version = data.AppVersion;
          this.menu.setAppVersion(this.app_version);
          // Reload/refresh the current page
          this.refresh();
        }
      });
    });

    // id_token & access_token refresh
    // Wait 10 minutes - then refresh the id_token and access_token every 10 minutes.
    const timer2 = observableTimer(600000, 600000);
    this.timer2Subscription = timer2.subscribe(t => {
      // Make a call to the server to determine if the version has changed
      this.authService.refreshTokens().subscribe(authTokenModel => {
        this.authService.idToken = authTokenModel.id_token;
        this.authService.accessToken = authTokenModel.access_token;
      });
    });
  }

  refresh(): void {
    // The key here is that we are routing to another (dummy) component page - but skipping the location change,
    // effectively staying right where we are but via a reload/refresh.
    this.router.navigateByUrl("/refresh-redirect", { skipLocationChange: true }).then(() => {
      // console.log(decodeURI(this.location.path()));
      this.router.navigate([decodeURI(this.location.path())]);
    });
  }

  ngOnDestroy() {
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    if (this.timer1Subscription) {
      this.timer1Subscription.unsubscribe();
    }

    if (this.timer2Subscription) {
      this.timer2Subscription.unsubscribe();
    }
  }

  ngDoCheck() {
    if (this.menuLinks !== this.oldMenuLinks) {
      this.oldMenuLinks = this.menuLinks;
    }

    //const $mainMenu = $('#main-menu');

    //if ($mainMenu.data('metisMenu')) {
      //$mainMenu.metisMenu('dispose');
    //}
  }

  ngAfterViewChecked() {
    //const $mainMenu = $('#main-menu');

    //if (!$mainMenu.data('metisMenu')) {
      //$mainMenu.metisMenu({ toggle: true });
    //}
  }
  
  isCollapsedChanged(
    isCollapsed: boolean
  ) {
    this.isCollapsed = isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle(link) {
    link.active = !link.active;
  }

  toggleV() {
    this.isExpandedV = !this.isExpandedV;
    this.verticalExpand.emit(this.isExpandedV);

  }
}
